export const ellipse1 = `
<svg width="1058" height="892" viewBox="0 0 1058 892" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.46" filter="url(#filter0_f_1201_6421)">
    <ellipse cx="718.5" cy="376.905" rx="418.5" ry="214.905" fill="#4374DF" fill-opacity="0.4"/>
    </g>
    <defs>
    <filter id="filter0_f_1201_6421" x="0" y="-138" width="1437" height="1029.81" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_1201_6421"/>
    </filter>
    </defs>
</svg>

`
